import { render } from "./BankTransaction.vue?vue&type=template&id=7e04232d&scoped=true"
import script from "./BankTransaction.vue?vue&type=script&lang=js"
export * from "./BankTransaction.vue?vue&type=script&lang=js"

import "./BankTransaction.vue?vue&type=style&index=0&id=7e04232d&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e04232d"]])

export default __exports__